import { useMemo } from "react";
import { useAtom } from "tiny-atom/react/hooks";

export default function useClient() {
  const patientData = useAtom(state => state.patientData);
  const client = useMemo(() => patientData?.childDetails, [patientData]);
  return client;
}
